import { View, Text } from "react-native";
import Icon from "@shared/components/md-design-system/Icon/Icon";
import { dynamicTranslations } from "@shared/utils/dynamicTranslation";

const ActivityCardCollapsed = ({ title, isPressed }: { title: string; isPressed: boolean }) => {
    const { t } = dynamicTranslations();
    const loading = false;
    const isActive = true;
    const disabled = loading || !isActive;

    return (
        <View className="flex-row items-center justify-between flex-1" style={{ minHeight: 20 }}>
            <View style={{ flex: 1, paddingRight: 12 }}>
                <Text
                    className={`text-base font-bold ${loading || !isActive
                            ? 'text-primary-700'
                            : isPressed
                                ? 'text-black-600'
                                : 'text-primary-700'
                        }`}
                    style={{
                        flexShrink: 1,
                        flexWrap: 'wrap',
                    }}
                    numberOfLines={2}>
                    {t(title)}
                </Text>
            </View>
            {isActive ? (
                <View
                    className={`min-w-9 min-h-9 rounded-[100%] justify-center items-center border ${loading || !isActive
                            ? 'border-gray-200 bg-gray-200'
                            : isPressed
                                ? 'border-primary-700 bg-primary-700'
                                : 'border-gray-300 bg-white'
                        }`}
                    style={{ flexShrink: 0 }}>
                    <Icon
                        name="arrow-right"
                        size={15}
                        color={loading || !isActive ? 'text-gray-400' : isPressed ? "white" : "primary-700"}
                    />
                </View>
            ) : null}
        </View>
    );
};


export default ActivityCardCollapsed;